@if (!media.isActive('lt-md')) {
  <app-chart-rank-items
    chartName="LINE MUSIC"
    [infos]="lineMusicInfo$ | async"
    [dataCollections]="dataCollections$ | async"
  ></app-chart-rank-items>
}
@if (media.isActive('lt-md')) {
  <app-sp-chart-rank-items
    chartName="LINE MUSIC"
    [infos]="lineMusicInfo$ | async"
    [dataCollections]="dataCollections$ | async"
  ></app-sp-chart-rank-items>
}
